import { Bin } from '../../../../../types/bin';
import { CustomFieldValue } from '../../../../../types/custom_field';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfBinProperty {
  name = 'name',
}

export class PdfBinDataResolver extends PdfEntityDataResolver<Bin, PdfBinProperty> {
  properties = Object.values(PdfBinProperty);
  entityType = PdfFieldEntity.bin;

  getCustomFieldByEntity(entity: Bin, id: string): CustomFieldValue | undefined {
    return entity.customFields.get(id);
  }

  getValueByProperty(property: PdfBinProperty, bin: Bin): string {
    switch (property) {
      case PdfBinProperty.name:
        return bin.name;
    }
  }

  getLabelByProperty(property: PdfBinProperty): string {
    switch (property) {
      case PdfBinProperty.name:
        return 'Bin Name';
    }
  }
}
